import { ApiService } from './ApiService';

class EquipmentService extends ApiService {
    findOne(id) {
        return this.Get(`/equipments/${id}`);
    }

    getAll(companyId) {
        return this.Get(`/equipments/company/${companyId}`);
    }

    addToTrail(equipmentId, trailId, price, companyId) {
        const payload = { trailId, price, companyId };
        return this.Post(`/equipments/${equipmentId}/to-trail`, payload);
    }

    removeFromTrail(equipmentId, trailId) {
        return this.Delete(`/equipments/${equipmentId}/from-trail/${trailId}`);
    }

    updateOnTrail(equipmentId, trailId, price, companyId) {
        return this.Put(`/equipments/${equipmentId}/to-trail/${trailId}`, {
            price,
            companyId,
        });
    }
}

export default new EquipmentService();
